import { connect } from 'react-redux'
import Globals from '../../../globals'
import * as selector from '../../state/funnel-builder/selector'
import * as action from '../../state/funnel-builder/action'
import FunnelBuilder from './FunnelBuilder'


const mapStateToProps = (state, props) => {
    return {
        processStateNameList: Globals.selector.selectProcessStateNameList(state),
        enrichedFunnelList: selector.selectEnrichedStepList(state),
        ...selector.selectOwnState(state),
        enrichedStateList: selector.selectEnrichedStateList(state),
        filteredStateList: selector.selectFilteredStateList(state),
    }
}

const mapDispatchToProps = {
    changeFunnelStartTime: action.changeFunnelStartTime,
    findCohort: action.findCohort,
    changeFunnelStep: action.changeFunnelStep,
    changeModeWeekly: action.changeModeWeekly,
    changeModeMonthly: action.changeModeMonthly,
}

export default connect(mapStateToProps, mapDispatchToProps)(FunnelBuilder)



// WEBPACK FOOTER //
// ./src/modules/analytics/component/funnel-builder/FunnelBuilderContainer.js